


















import { Vue, Component, Prop } from "vue-property-decorator";
import SVGIcon from "@/components/SVGIcon.vue";
import LanguageSelector from "@/components/LanguageSelector.vue";
import { mapActions, mapState } from 'vuex';

@Component({
  components: {
    SVGIcon,
    LanguageSelector,
  },
  methods: {
    ...mapActions('global', ['toggleCart'])
  },
  computed: {
    ...mapState('global', ['cartOpen', 'cart'])
  }
})
export default class Header extends Vue {
  langNav = false;
  
  toggleLangNav () {
    this.langNav = !this.langNav
  }

  hideLangNav () {
    this.langNav = false
  }
}
